const PROJECT_NAME = (process.env.REACT_APP_PROJECT_NAME || 'eliosdrive') as ProjectName;

type ProjectName = 'logsfly' | 'eliosdrive';

const PROJECTS: Record<ProjectName, {
  name: string;
  logo: string;
  logoBig: string;
  alt: string;
  logoIcon: string;
  favicon: string;
  storagePrefix: string;
}> = {
  logsfly: {
    name: 'logsfly',
    alt: 'LogsFly',
    logo: '/images/logsfly/logo.png',
    logoBig: '/images/logsfly/logo_big.png',
    logoIcon: '/images/logsfly/logo-icon.png',
    favicon: '/images/logsfly/favicon.ico',
    storagePrefix: 'logsfly_',
  },
  eliosdrive: {
    name: 'eliosdrive',
    alt: 'EliosDrive',
    logo: '/images/eliosdrive/logo.png',
    logoBig: '/images/eliosdrive/logo_big.png',
    logoIcon: '/images/eliosdrive/logo-icon.png',
    favicon: '/images/eliosdrive/favicon.ico',
    storagePrefix: 'eliosdrive_',
  },
};

export const PROJECT_CONFIG = PROJECTS[PROJECT_NAME];